import { createContext } from '@lit/context';

import { ModalService } from '../services/luds-modal-service';

export const modalServiceContext = createContext<ModalService>(Symbol('modal-service'));
